module.exports = __webpack_public_path__ + "static/media/about.9f486739.svg";